.biel-message {
    display: flex;
    align-items: flex-start;
    max-width: calc(100% - var(--biel-message-avatar-width));
    width: fit-content;
    padding: var(--biel-message-padding);
    margin: 5px 0;
    border-radius: var(--biel-message-border-radius);
}

.biel-message--user {
    color: var(--biel-message-user-text-color);
    background-color: var(--biel-message-user-bg-color);
}

.biel-message--ai {
    color: var(--biel-message-biel-text-color);
    background-color: var(--biel-message-biel-bg-color);
}

.biel-message__content * {
    margin: 0;
}

.biel-message__content ul,
.biel-message__content ol {
    padding-inline-start: 0;
    margin-left: 20px;
}

.biel-message__content>div>ul,
.biel-message__content>div>ol {
    padding: 0;
}

.biel-message__content>div:not(:first-child),
.biel-message__content li,
.biel-message__content p:not(:first-child),
.biel-message__content h1,
.biel-message__content h2,
.biel-message__content h3,
.biel-message__content h4,
.biel-message__content h5,
.biel-message__content h6 {
    margin-top: 10px;
}
.biel-message__content h1 {
    font-size: var(--biel-message-h1-font-size);
}

.biel-message__content h2 {
    font-size: var(--biel-message-h2-font-size);
}

.biel-message__content h3 {
    font-size: var(--biel-message-h3-font-size);
}

.biel-message__content h4 {
    font-size: var(--biel-message-h4-font-size);
}

.biel-message__content h5 {
    font-size: var(--biel-message-h5-font-size);
}

.biel-message__content h6 {
    font-size: var(--biel-message-h6-font-size);
}

.biel-message__content pre {
    margin: 10px 0;
}

.biel-message__content a {
    color: var(--biel-message-link-color);
    text-decoration: none;
}

.biel-message__content a:hover {
    text-decoration: underline;
}

.biel-message__avatar {
    width: var(--biel-message-avatar-width);
    height: var(--biel-message-avatar-height);
    border-radius: 50%;
    margin-right: var(--biel-message-avatar-margin-right);
}

.biel-message__content {
    max-width: calc(100% - var(--biel-message-avatar-width) - var(--biel-message-avatar-margin-right));
    display: flex;
    flex-direction: column;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.4;
}


.biel-table-container {
    margin: 10px 0;
    overflow-x: auto;
    background-color: var(--biel-table-bg-color);
    border-radius: 6px;
}

.biel-table-container table {
    width: 100%;
    border-collapse: collapse;
    overflow: hidden;
    color: var(--biel-table-content-text-color);
}

.biel-table-container th,
.biel-table-container td {
    padding: 8px;
    border: 1px solid #303030;
}

.biel-table-container th {
    background-color: var(--biel-table-th-bg-color);
}

.biel-table-container::-webkit-scrollbar {
    height: 8px;
}

.biel-table-container::-webkit-scrollbar-thumb:horizontal {
    background-color: var(--biel-chat-scrollbar-color);
    border-radius: 10px;
    border: 3px solid transparent;
}

.biel-table-container::-webkit-scrollbar-thumb:hover {
    background-color: var(--biel-chat-scrollbar-hover-color);
}

.biel-message__content code {
    background-color: var(--biel-message-code-inline-bg-color);
    padding: 2px 4px;
    border-radius: var(--biel-message-code-inline-border-radius);
    font-size: var(--biel-message-code-font-size);
    color: var(--biel-message-code-inline-text-color);
}

.biel-message__content pre code {
    color: initial;
    background-color: var(--biel-message-code-bg-color);
}